import { render, staticRenderFns } from "./facets.vue?vue&type=template&id=47851702"
import script from "./facets.vue?vue&type=script&lang=js"
export * from "./facets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports